// extracted by mini-css-extract-plugin
export default {"badge":"StatusBadge_badge__YWFGN","pending":"StatusBadge_pending__nDJ92","confirmed":"StatusBadge_confirmed__IHuFk","rejected":"StatusBadge_rejected__2-9Pt"};